import { AdminTasksSliceStateInterface } from 'store/reducers/adminTasks/types';

export const initialAdminTasksStoreState: AdminTasksSliceStateInterface = {
  adminTasksData: {
    tasks: [],
    taskInfo: null,
    loading: false,
  },
};
